import React from 'react';
import { Button, Col } from 'reactstrap';
import { Link } from 'react-router-dom';
import * as Yup from 'yup';
import { AMEND_LICENCE_URL, DASHBOARD_PATH, DEFAULT_PAYMENT_OPTION, GENERAL_INFORMATION_VALIDFORMTYPE, GET_FEES_LICENCES_URL, GET_LICENCE_DETAILS_URL, GET_SFORM_FORM_DATA_FROM_APP_TYPE_URL, LAYOUT_TYPE, PAYMENT_OPTIONS } from '../../App/AppSettings';
import Layout from '../../Layout';
import Section from '../../Section';
import SectionWrapper from '../../SectionWrapper';
import { fetchRequest, getParams } from '../../Shared/Actions';
import { BLS_FORM_APP_TYPES, BUTTON_TYPE, DELETE_FILES_ARRAY, SECTION_WRAPPER_TYPES } from '../../Shared/Constants';
import { SMARTForm } from '../../Shared/Forms';
import { toastError } from '../../Shared/Forms/Toaster';
import history from '../../Shared/History';
import { withLoader } from '../../Shared/Loading';
import PageFooter from '../../Shared/PageFooter';
import { getFormNames, getRemoteList, getTableListValues } from '../FormComponents/FormUtils';
import { GeneralInformationComponent } from '../FormComponents/GeneralInformation/GeneralInformationComponent';
import { getAddressTypeOptions } from '../FormComponents/GeneralInformation/Utils.js';
import { createValidationSchemaForDeclaration, createValidationSchemaForGeneralInfo, createValidationSchemaForLicenceFields, createValidationSchemaForSupportingDocuments } from '../FormComponents/LicenceApplicationInformation/ValidationSchema';
import PaymentSummary from '../FormComponents/PaymentSummary';
import SupportingDocuments from '../FormComponents/SupportingDocuments';
import RFAReviewAndSubmit from '../RFAResponse/RFAReviewAndSubmit';
import FormAmend from './FormAmend';
import { withTranslation } from 'react-i18next';
import { ERROR, LANGUAGE_KEYS, WIZARD_TAB_NAMES } from '../../Shared/Constants/LanguageKeys';
import { getLangKey } from '../DisplayComponents/DisplayUtils';

const SECTION_LAYOUT_TYPE = SECTION_WRAPPER_TYPES.WIZARD;
const FORM_CONTEXT = 'AmendLicence';

const PAYMENT_TAB_DISPLAY = true;

class AmendLicence extends React.Component {
    constructor(props) {
        super(props);

        if (history.location.state) {
            this.state = {
                licenceId: history.location.state.IntroductoryNotes.LicenceId,
                selectedIdTypeArr: [],
                idNumberArr: [],
                addressTypeOptions: getAddressTypeOptions(),
                values: null,
                licence: null,
                formNames: null,
                licenceFees: [],
                totalLicenceFee: '',
                optionDataList: {},
                onlineBtn: BUTTON_TYPE.ACTIVE,
                offlineBtn: BUTTON_TYPE.INACTIVE
            };
        }
    }
    async componentDidMount() {
        const { loader } = this.props;
        const { licenceId } = this.state;
        loader.start();

        this.getLicenceData(licenceId, loader);
    }

    async getLicenceAmendmentData(licenceID, appRefNum, loader) {
        const { t } = this.props;
        const params = {
            licenceId: licenceID,
            appType: BLS_FORM_APP_TYPES.AMEND
        };
        const response = await fetchRequest(GET_SFORM_FORM_DATA_FROM_APP_TYPE_URL, getParams(params));
        const { IsSuccess, Data, Messages } = response.body;

        if (response.success && IsSuccess) {
            const licenceDetails = Object.assign({}, Data, { FormData: JSON.parse(Data.FormData) });

            await this.getOptionsDataList(licenceDetails);

            this.getFormFees(licenceDetails.FormDefinition.FormType);

            this.setState(() => {
                return {
                    licenceDetails,
                    formNames: getFormNames(this.state.licence.LicenceName, licenceDetails.DocumentList, PAYMENT_TAB_DISPLAY),
                    values: this.getFilledValues(licenceDetails.FormDefinition, licenceDetails.FormData, licenceDetails.GeneralDefinition,
                        licenceDetails.DocumentList, licenceDetails.GeneralDefinition.FormType, appRefNum),
                    validationSchema: this.createValidationSchema(licenceDetails, licenceDetails.GeneralDefinition.FormType),
                    declarations: licenceDetails.DeclarationList,
                    generalInformationType: licenceDetails.GeneralDefinition.FormType
                };
            }, () => {
                loader.done();
            });
        } else {
            loader.done();
            toastError(t(getLangKey(ERROR.BACKEND_ERROR_MESSAGE, Messages)), Messages);
        }
    }

    async getLicenceData(licenceId, loader) {
        const response = await fetchRequest(GET_LICENCE_DETAILS_URL + licenceId, getParams(), false);
        const { IsSuccess, Data } = response.body;
        if (IsSuccess) {
            this.setState(() => {
                return {
                    licence: Object.assign({}, Data, { LicenceData: JSON.parse(Data.LicenceData) }),
                    licenceDetailsLoaded: true
                };
            }, () => {
                this.getLicenceAmendmentData(this.state.licence.LicenceID, this.state.licence.ApplicationRefNumber, loader);
            });
        }
    }

    async getFormFees(formType) {
        const queryString = {
            feeType: BLS_FORM_APP_TYPES.AMEND,
            formTypes: formType
        };
        const response = await fetchRequest(GET_FEES_LICENCES_URL, getParams(queryString), false);
        const { IsSuccess, Data } = response.body;

        if (IsSuccess) {
            const isDataPresent = Data && Data.LicenceFeeItemList && Data.LicenceFeeItemList.length > 0;
            this.setState({
                licenceFees: isDataPresent ? Data.LicenceFeeItemList : [],
                totalLicenceFee: isDataPresent ? Data.TotalLicenceFee : ''
            });
        }
    }

    getOptionsDataList = async devData => {
        const { t } = this.props;
        const listOfCategory = [];
        //loop through all the fields to collate all the options required for the entire form

        //GeneralDefinition
        devData.GeneralDefinition.Sections.forEach(section => {
            section.Fields.forEach(field => {
                const isRemote = field.DataSource !== undefined && field.DataSource === 'Remote';
                if (isRemote && listOfCategory.indexOf(field.DataParameters.Category) < 0) {
                    listOfCategory.push(field.DataParameters.Category);
                }
            });
        });

        //FormDefinition
        devData.FormDefinition.Sections.forEach(formDefSection => {
            formDefSection.Fields && formDefSection.Fields.forEach(formDefField => {
                const isRemote = formDefField.DataSource !== undefined && formDefField.DataSource === 'Remote';
                if (isRemote && listOfCategory.indexOf(formDefField.DataParameters.Category) < 0) {
                    listOfCategory.push(formDefField.DataParameters.Category);
                }
            });
            formDefSection.Table && formDefSection.Table.Fields.forEach(formDefTableField => {
                const isRemote = formDefTableField.DataSource !== undefined && formDefTableField.DataSource === 'Remote';
                if (isRemote && listOfCategory.indexOf(formDefTableField.DataParameters.Category) < 0) {
                    listOfCategory.push(formDefTableField.DataParameters.Category);
                }
            });
        });

        let totalOptionsList = null;
        if (listOfCategory.length !== 0) {
            totalOptionsList = await getRemoteList(t, listOfCategory);
        }

        this.setState({
            optionDataList: totalOptionsList
        });
    }

    getFilledValues = (formDefinition, formData, generalInfoFields, documentList, generalInformationType, appRefNumber) => {
        const licenceFieldNames = {};
        const formTypeNames = {
            FormTypes: [formDefinition.FormType, GENERAL_INFORMATION_VALIDFORMTYPE]
        };

        const licenceInfo = formData.LicenceInformation;
        const generalInfo = formData.GeneralInformation;
        licenceFieldNames[formDefinition.FormType] = {};

        const tableValueKeys = Object.keys(licenceInfo);

        //get filled values for licence fields
        formDefinition.Sections.forEach(section => {
            section.Fields && section.Fields.forEach(field => {
                if (licenceInfo[field.Name] !== undefined && licenceInfo[field.Name] !== '') {
                    licenceFieldNames[formDefinition.FormType][field.Name] = licenceInfo[field.Name];
                }
                else {
                    licenceFieldNames[formDefinition.FormType][field.Name] = '';
                }
            });

            if (section.Table) {
                licenceFieldNames[formDefinition.FormType][section.Name] = [];
                const sectionTableList = getTableListValues(tableValueKeys, section.Name);

                sectionTableList && sectionTableList[section.Name].forEach((row, rindex) => {
                    const newTableArrObj = {};
                    section.Table.Fields && section.Table.Fields.forEach(field => {
                        if (licenceInfo[`${section.Name}.${rindex}.${field.Name}`] !== undefined && licenceInfo[`${section.Name}.${rindex}.${field.Name}`] !== '') {
                            newTableArrObj[field.Name] = licenceInfo[`${section.Name}.${rindex}.${field.Name}`];
                        }
                        else {
                            newTableArrObj[field.Name] = '';
                        }
                    });
                    licenceFieldNames[formDefinition.FormType][section.Name].push(newTableArrObj);
                });
            }
        });

        const generalFieldNames = {
            GeneralInformation: {}
        };

        //get filled values for general info fields
        generalInfoFields.Sections.forEach(section => {
            section.Fields.forEach(field => {
                if (generalInfo[field.Name] !== undefined && generalInfo[field.Name] !== '') {
                    generalFieldNames.GeneralInformation[field.Name] = generalInfo[field.Name];
                }
                else {
                    generalFieldNames.GeneralInformation[field.Name] = '';
                }
            });
        });

        /*old supporting documents should not be extracted*/
        const supportingDocumentNames = {
            SupportingDocument: {}
        };

        documentList.forEach(field => {
            supportingDocumentNames.SupportingDocument[field.Name] = [];
        });

        const finalFields = {
            ...formTypeNames, ...generalFieldNames, ...licenceFieldNames, ...supportingDocumentNames,
            GeneralInformationType: generalInformationType,
            PaymentOption: DEFAULT_PAYMENT_OPTION
        };
        finalFields[DELETE_FILES_ARRAY] = [];
        finalFields.AppRefNum = appRefNumber;
        return finalFields;
    }

    createValidationSchema = (devData, generalInformationType) => {
        const { t } = this.props;
        const validationObject = {

            /***********************/
            /*** General Section ***/
            /***********************/
            GeneralInformation: createValidationSchemaForGeneralInfo(t, generalInformationType),

            /***********************/
            /*** Licence Section ***/
            /***********************/
            [devData.FormDefinition.FormType]: createValidationSchemaForLicenceFields(t, devData.FormDefinition),

            // /***********************************/
            // /*** Supporting Document Section ***/
            // /***********************************/
            SupportingDocument: createValidationSchemaForSupportingDocuments(t, devData.DocumentList),

            /***************************/
            /*** Declaration Section ***/
            /***************************/
            DeclarationAgreement: createValidationSchemaForDeclaration(t)
        };
        return Yup.object().shape(validationObject);
    }

    choosePaymentOption = (paymentOption, values) => {
        values.PaymentOption = paymentOption;

        if (paymentOption === PAYMENT_OPTIONS.ONLINE) {
            this.setState({
                onlineBtn: BUTTON_TYPE.ACTIVE,
                offlineBtn: BUTTON_TYPE.INACTIVE
            });
        } else {
            this.setState({
                onlineBtn: BUTTON_TYPE.INACTIVE,
                offlineBtn: BUTTON_TYPE.ACTIVE
            });
        }
    }

    render() {
        const { t } = this.props;
        const { licenceDetails, values, licence, formNames, totalLicenceFee, generalInformationType, declarations, optionDataList } = this.state;
        if (!values || !licence || !formNames) {
            return null;
        } else {
            const GeneralInformationComponentInput = GeneralInformationComponent[generalInformationType];

            return (
                <>
                    <div className="main-content">
                        <nav aria-label="breadcrumb" className="breadcrumb-main">
                            <div className="container">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to={DASHBOARD_PATH}>{t(LANGUAGE_KEYS.BLS_PUBLICWORKSPACE_NAVIGATION_MENU_WORKSPACE2)}</Link></li>
                                    <li className="breadcrumb-item"><Link to={DASHBOARD_PATH}>{t(LANGUAGE_KEYS.BLS_PUBLICHOME_NAV_MENU_AMENDLICENCE)}</Link></li>
                                    <li className="breadcrumb-item active" aria-current="page">{licence.LicenceName}</li>
                                </ol>
                            </div>
                        </nav>
                        <Layout type={LAYOUT_TYPE.FORM} footer>
                            <SMARTForm
                                formContext={FORM_CONTEXT}
                                className="container"
                                sectionNames={formNames}
                                defaultSection={Object.keys(formNames)[0]}
                                formValues={this.state.values}
                                validationSchema={this.state.validationSchema}
                                validateOnSubmit={true}
                                serverURL={AMEND_LICENCE_URL}
                                nextURL={AMEND_LICENCE_URL}
                            >
                                {({ toggleSection, toggleAllSections, sectionState, onChange, onChangeField, values,
                                    submitForm, errors, currentStep, prevStep, nextStep, modalError, modalStateError }) => {

                                    const smartFormValues = {
                                        toggleSection,
                                        toggleAllSections,
                                        values,
                                        onChange,
                                        onChangeField,
                                        errors,
                                        modalError,
                                        modalStateError
                                    };
                                    return (
                                        <React.Fragment>
                                            <Col>
                                                <SectionWrapper
                                                    type={SECTION_LAYOUT_TYPE}
                                                    tabs={this.state.formNames}
                                                    sectionState={sectionState}
                                                    toggleSection={toggleSection}>
                                                    <Section
                                                        type={SECTION_LAYOUT_TYPE}
                                                        sectionState={sectionState}
                                                        toggleSection={toggleSection}
                                                        sectionName={t(WIZARD_TAB_NAMES.GENERAL_INFORMATION)}
                                                        key={t(WIZARD_TAB_NAMES.GENERAL_INFORMATION)}>
                                                        <GeneralInformationComponentInput
                                                            smartFormValues={smartFormValues}
                                                            state={this.state}
                                                        />
                                                    </Section>
                                                    <Section
                                                        type={SECTION_LAYOUT_TYPE}
                                                        sectionState={sectionState}
                                                        toggleSection={toggleSection}
                                                        sectionName={licence.LicenceName}>
                                                        <FormAmend
                                                            smartFormValues={smartFormValues}
                                                            formDefinition={licenceDetails.FormDefinition}
                                                            formName={licence.LicenceName}
                                                            licence={licence}
                                                            formType={licenceDetails.FormDefinition.FormType}
                                                            optionDataList={optionDataList}
                                                        />
                                                    </Section>
                                                    {licenceDetails && licenceDetails.DocumentList && licenceDetails.DocumentList.length > 0 &&
                                                        <Section
                                                            type={SECTION_LAYOUT_TYPE}
                                                            sectionState={sectionState}
                                                            toggleSection={toggleSection}
                                                            sectionName={t(WIZARD_TAB_NAMES.SUPPORTING_DOCUMENTS)}
                                                            key={t(WIZARD_TAB_NAMES.SUPPORTING_DOCUMENTS)}>
                                                            <SupportingDocuments
                                                                smartFormValues={smartFormValues}
                                                                files={licenceDetails.DocumentList}
                                                            />
                                                        </Section>
                                                    }
                                                    <Section
                                                        type={SECTION_LAYOUT_TYPE}
                                                        sectionState={sectionState}
                                                        toggleSection={toggleSection}
                                                        sectionName={t(WIZARD_TAB_NAMES.REVIEW_INFORMATION)}
                                                        key={t(WIZARD_TAB_NAMES.REVIEW_INFORMATION)}>
                                                        <RFAReviewAndSubmit
                                                            smartFormValues={smartFormValues}
                                                            applicationDetails={licenceDetails}
                                                            declarations={declarations}
                                                            displayDocuments={licenceDetails && licenceDetails.DocumentList && licenceDetails.DocumentList.length > 0}
                                                        />
                                                    </Section>
                                                    <Section
                                                        type={SECTION_LAYOUT_TYPE}
                                                        sectionState={sectionState}
                                                        toggleSection={toggleSection}
                                                        sectionName={t(WIZARD_TAB_NAMES.PAYMENTS)}
                                                        key={t(WIZARD_TAB_NAMES.PAYMENTS)}>
                                                        <PaymentSummary
                                                            licenceFees={this.state.licenceFees}
                                                            totalLicenceFee={this.state.totalLicenceFee}
                                                            choosePaymentOption={option => this.choosePaymentOption(option, values)}
                                                            hidePaymentOption={this.state.totalLicenceFee > 0 ? false : true}
                                                            onlineBtn={this.state.onlineBtn}
                                                            offlineBtn={this.state.offlineBtn}
                                                        />
                                                    </Section>
                                                </SectionWrapper>

                                            </Col>
                                            <PageFooter type={LAYOUT_TYPE.FORM}>
                                                <div className="button-center">

                                                    {/* Wizard Previous Button */}
                                                    {((LAYOUT_TYPE.FORM_CONTENT === 3) && (currentStep !== 0)) ?
                                                        <Button color="backward" size="sm" type="button" onClick={prevStep}>
                                                            {t(LANGUAGE_KEYS.BLS_PUBLICAPPLICATION_NAVIGATION_BUTTON_PREVIOUS)}
                                                        </Button> : ''
                                                    }

                                                    {/* Submit Button */}
                                                    {((LAYOUT_TYPE.FORM_CONTENT === 3) && (currentStep === Object.keys(this.state.formNames).length - 1)) ?
                                                        <Button color="forward" size="sm" type="button" onClick={submitForm}>
                                                            {totalLicenceFee > 0 ? t(LANGUAGE_KEYS.BLS_PUBLICAPPLICATION_CONTENT_BUTTON_PAY) : t(LANGUAGE_KEYS.BLS_PUBLICWORKSPACEAPPLICATION_NAVIGATION_BUTTON_SUBMIT)}
                                                        </Button> :
                                                        ((LAYOUT_TYPE.FORM_CONTENT !== 3) &&
                                                            <Button color="forward" size="sm" type="button" onClick={submitForm}>
                                                                {totalLicenceFee > 0 ? t(LANGUAGE_KEYS.BLS_PUBLICAPPLICATION_CONTENT_BUTTON_PAY) : t(LANGUAGE_KEYS.BLS_PUBLICWORKSPACEAPPLICATION_NAVIGATION_BUTTON_SUBMIT)}
                                                            </Button>
                                                        )
                                                    }

                                                    {/* Wizard Next Button */}
                                                    {((LAYOUT_TYPE.FORM_CONTENT === 3) && (currentStep !== Object.keys(this.state.formNames).length - 1)) ?
                                                        <Button color="forward" size="sm" type="button" onClick={nextStep}>
                                                            {t(LANGUAGE_KEYS.BLS_PUBLICAPPLICATION_NAVIGATION_BUTTON_NEXT)}
                                                        </Button> : ''}
                                                </div>
                                            </PageFooter>
                                        </React.Fragment>
                                    );
                                }
                                }

                            </SMARTForm>
                        </Layout>


                    </div>

                </>
            );
        }
    }
}
export default withTranslation()(withLoader(AmendLicence));
